import { render } from "./AdminReservations.vue?vue&type=template&id=e61087f2&scoped=true"
import script from "./AdminReservations.vue?vue&type=script&lang=js"
export * from "./AdminReservations.vue?vue&type=script&lang=js"

import "./AdminReservations.vue?vue&type=style&index=0&id=e61087f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e61087f2"]])

export default __exports__